export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-950"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20burgundy%20and%20deep%20crimson%20tones%2C%20subtle%20film%20strip%20texture%20patterns%2C%20soft%20golden%20bokeh%20light%20effects%2C%20luxurious%20movie%20theater%20atmosphere%2C%20elegant%20minimalist%20dark%20gradient%20background%20with%20flowing%20geometric%20shapes%2C%20rich%20amber%20highlight%20accents%2C%20no%20text%20or%20logos%2C%20professional%20cinematic%20aesthetic%2C%20sophisticated%20artistic%20backdrop%20for%20film%20streaming%20platform%20hero%20section&width=1600&height=800&seq=jiubo-hero-2026&orientation=landscape"
        alt="久播影院 - 高清免费在线观影平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-background-950/70 via-background-950/60 to-background-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs md:text-sm font-medium text-accent-300 bg-accent-500/15 rounded-full border border-accent-500/25 mb-4 md:mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>每日更新 · 流畅不卡顿
            </span>

            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 leading-tight mb-3 md:mb-4">
              久播影院 · 高清免费在线观影平台
            </h1>

            <p className="text-sm md:text-base font-heading text-accent-300/90 mb-5 md:mb-6 italic">
              最新最全的电影库，随时随地免费看
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-6 md:mb-8 max-w-xl lg:max-w-none">
              久播影院汇集全球海量电影资源，涵盖动作、科幻、悬疑、喜剧、动画等全品类题材。
              每日更新片库，采用智能加速技术确保高清流畅播放，无需注册、无需付费，
              打开网页即可畅享影院级观影体验。本周热推「暑期档爆款合集」与「高分悬疑片单」，
              多部院线新片已上线，错过影院的朋友来久播补课正当时。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-5 md:gap-8 mb-6 md:mb-8">
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-accent-300">12,000+</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">海量影片</div>
              </div>
              <div className="w-px h-10 bg-background-500/30"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-accent-300">每日更新</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">片库不断</div>
              </div>
              <div className="w-px h-10 bg-background-500/30"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-accent-300">4K超清</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">影院画质</div>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 md:gap-4 flex-wrap">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-5 md:px-7 py-2.5 md:py-3 bg-primary-500 text-background-50 font-medium text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-5 md:px-7 py-2.5 md:py-3 border border-background-300/50 text-background-100 font-medium text-sm md:text-base rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative w-full max-w-md lg:max-w-none">
              <div className="aspect-video rounded-xl overflow-hidden border border-background-300/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20floating%20movie%20poster%20fragments%2C%20warm%20golden%20spotlight%20rays%2C%20elegant%20film%20reel%20elements%2C%20rich%20burgundy%20and%20amber%20color%20palette%2C%20soft%20theatrical%20glow%2C%20abstract%20movie%20scene%20montage%2C%20luxurious%20cinema%20atmosphere%2C%20no%20text%2C%20professional%20film%20industry%20aesthetic%2C%20dramatic%20lighting%20with%20deep%20shadows&width=1200&height=675&seq=jiubo-hero-visual&orientation=landscape"
                  alt="久播影院精选影片视觉展示"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 bg-primary-500 text-background-50 rounded-lg px-3 md:px-4 py-1.5 md:py-2 text-xs md:text-sm font-medium whitespace-nowrap shadow-lg">
                <i className="ri-flashlight-line mr-1.5"></i>新片每日上线
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}